import React, { useEffect, useState } from 'react';
import {useTranslation} from 'react-i18next';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Box from '@material-ui/core/Box';

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import {Info, ArrowUpward, ChevronRight, Check} from "@material-ui/icons";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";

import MaterialTable from 'material-table';
import Search from '@material-ui/icons/Search';
import Clear from '@material-ui/icons/Clear';
import CustomCheckBox from 'components/elements/CustomCheckbox'
import CustomCheckBox2 from 'components/elements/CustomCheckBox2'
import CachedIcon from '@material-ui/icons/Cached';
import { CustomButton, CustomTable } from 'components/elements';
import { ParkingSymbol } from 'components/common';
import { renderConnectionStatus } from 'utils';
import CheckIcon from '@material-ui/icons/Check';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import {CircularProgress} from "@material-ui/core";
import ErrorIcon from '@material-ui/icons/Error';

const useStyles = makeStyles((theme) => ({
    formFields: {
        height: '100%',
        width: '100%',
        flexDirection: 'row',
        
        alignItems: 'flex-start',
        paddingTop: '20px',
    },
    editorWrapper: {
        height: '100%',
        width: '100%',
        padding: theme.spacing(3.25, 4, 4, 4),
    },
    description: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '10px',
        fontWeight: 400,
        lineHeight: 1,
        letterSpacing: '0.06px',
        marginLeft: '30px',
    },
    errorMessage: {
        fontSize: 13,
        color: theme.palette.primary.red,
    },
    synchContainer: {
        marginTop: '30px',
        flexDirection: 'row', display: 'flex'
    },
    parkingContainer: {
        flexDirection: 'row', display: 'flex'
    },
    syncButton: {
        borderRadius: '10px',
        paddingLeft: '10px',
        paddingRight: '20px'
    },
    syncTitle: {
        marginRight: '30px', marginTop: '10px'
    },
    checkbox: {
        backgroundColor: 'white',
        color: 'black',
        "&:hover": {
            backgroundColor: '#F6F6F6',
        }
        
    }
}));

function ExtUserUpdate(props) {
    const classes = useStyles();

    const {
        roles,
        rowClickHandel,
        headerClickHandel,
        headerChecked,
        handleChange,
        handleChangeParking,
        updatedUser,
        error,
        readOnly,
        subjects,
        parkings,
        codeList,
        isNew,
        synchUser,
        errorSynch,
        doneSynch
    } = props;

    const {t} = useTranslation();
    const [userParkings, setUserParkings] = useState([]);

    useEffect(()=>{
        if ( parkings && updatedUser && updatedUser.parkingIds ) {
            let tmp = parkings.filter(item=>updatedUser.parkingIds.split(',').includes(String(item.gmtpIdent)));
            setUserParkings([...tmp]);
        }
    }, [parkings, updatedUser])

    const handleCheckbox = (parking) => {
        setUserParkings(userParkings.map(item=>item.parkingId===parking.parkingId?{...item, checkBox:!item.checkBox}:item));
    }

    const handleSynchronization = () => {
        setUserParkings(userParkings.map(item=>item.checkBox?{...item, synch:'IN_PROGRESS'}:item));
        let tmp = userParkings.filter(item=>item.checkBox).map(item=>item.parkingId).toString();
        synchUser(tmp);
    }

    useEffect(()=>{
        if ( errorSynch && userParkings ) {
            setUserParkings(userParkings.map(item=>errorSynch.includes(item.parkingId)?{...item, synch:'ERROR'}:item));
        }
        if ( doneSynch && userParkings ) {
            setUserParkings(userParkings.map(item=>doneSynch.includes(item.parkingId)?{...item, synch:'OK'}:item));
        }
    }, [errorSynch, doneSynch]);

    const tableOptions = {
        headerStyle: {
            padding: '15px 8px 15px 34px',
            lineHeight: '12px',
            color: '#1B1B28',
            textAlign: 'center',
        },
        paging: false
    };
    const cellStyle = {
        paddingLeft: 4,
        paddingRight: 4,
        lineHeight: '19px',
        color: '#1B1B28',
    };
    const columns = [
        {
            title: '',
            field: 'action',
            sorting: false,
            cellStyle: {
                ...cellStyle,
                padding: '12px 4px',
            },
            headerStyle: {
                padding: '18px 34px',
            },
            render: (rowData) => (
                    <CustomCheckBox 
                        className={classes.checkbox} 
                        handleChange={()=>{handleCheckbox(rowData)}} 
                        checked={rowData.checkBox}
                        disabled={rowData.communicationStatus!=='OK'}
                    />
            ),
        },
        {   title: t('NAME'),
            field: 'name',
            headerStyle: {textAlign: 'left', paddingLeft: 5},
            cellStyle: {
                ...cellStyle,
                align: 'center', paddingLeft: 5
            },
            render: (rowData) => (
                <div className={classes.parkingContainer}>
                    <ParkingSymbol
                        className={classes.symbol}
                        color={rowData.color}
                        connectionType={rowData.connectionType}
                        width={'35px'}
                        widthSymbol={'35px'}
                        variant='h5'
                    />
                    <div style={{fontSize: 22, marginLeft:'30px', paddingTop: '10px'}}>{rowData.parkingName}</div>
                </div>
                
            )
        },        
        {   title: t('PARKING_STATE'),
            field: 'state',
            headerStyle: {textAlign: 'left', paddingLeft: 5},
            cellStyle: {
                ...cellStyle,
                align: 'center', paddingLeft: 5
            },
            render: (rowData) => (
                <div>
                    {renderConnectionStatus(rowData.connectionType, rowData.communicationStatus, false, "", classes, t)}
                </div>
            )
        },
        {   title: t('PARKING_SYNCH'),
            field: 'synch',
            headerStyle: {textAlign: 'left', paddingLeft: 5},
            cellStyle: {
                ...cellStyle,
                align: 'center', paddingLeft: 5
            },
            render: (rowData) => (
                <div>
                    {rowData.synch === 'OK' && 
                        <>
                            <CheckIcon color='secondary'/>
                        </>
                    }
                    {rowData.synch === 'IN_PROGRESS' && 
                        <>
                            <CircularProgress />
                        </>
                    }
                    {rowData.synch === 'ERROR' && 
                        <>
                            <ErrorIcon color='error'/>
                        </>
                    }
                    {!rowData.synch && 
                        <>
                            <HelpOutlineIcon />
                        </>
                    }
                </div>
            )
        },   
    ]

    return (
        <div className={classes.formFields}>
            <form autoComplete='off'>
                <Box mb={2} height="100%" width="100%">
                    <Grid container spacing={2} sm={12}>
                        <Grid container spacing={1} sm={6} style={{marginLeft: "auto", marginRight: "auto"}}>
                            <Grid item xs sm={12} spacing={1} >
                                <Grid container spacing={2}>
                                    <Grid item xs={6} spacing={1} >
                                        <TextField
                                            style={{height: '60px'}}
                                            autoFocus
                                            helperText={error && error.userName
                                                ?
                                                <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                                                : null}
                                            fullWidth
                                            required
                                            disabled={readOnly}
                                            id="userName"
                                            value={updatedUser.userName || ''}
                                            onChange={handleChange('userName', false)}
                                            label={t('USER_NAME')}/>
                                    </Grid>

                                    <Grid item xs={6} spacing={1} >
                                        <TextField
                                            style={{height: '60px'}}
                                            autoFocus
                                            helperText={error && error.xapiKey
                                                ?
                                                <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                                                : null}
                                            fullWidth
                                            required
                                            disabled={readOnly}
                                            id="xapiKey"
                                            value={updatedUser.xapiKey || ''}
                                            onChange={handleChange('xapiKey', false)}
                                            label={t('API_KEY')}/>
                                    </Grid>

                                    <Grid item xs={6} spacing={1} >
                                        <FormControl required fullWidth disabled={false} style={{height: '60px'}}>
                                            <InputLabel id="active-label">
                                                {t('USER_ACTIVE')}
                                            </InputLabel>
                                            <Select
                                                autoWidth
                                                disabled={readOnly}
                                                value={updatedUser.active || ''}                                        
                                                id="active"
                                                onChange={handleChange('active', true)}
                                            >
                                                <MenuItem value=''>-</MenuItem>
                                                <MenuItem value={'true'}>{t('YES')}</MenuItem>
                                                <MenuItem value={'false'}>{t('NO')}</MenuItem>
                                            </Select>
                                            <FormHelperText>  {error && error.active && (
                                                <span className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                                            )}</FormHelperText>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6} spacing={1} >
                                        <FormControl fullWidth disabled={false} style={{height: '60px'}}>
                                            <InputLabel id="subjectId-label">
                                                {t('SUBJECT')}
                                            </InputLabel>
                                            <Select
                                                autoWidth
                                                disabled={readOnly}
                                                value={updatedUser.subjectId || ''}
                                                id="subjectId"
                                                onChange={handleChange('subjectId', true)}
                                            >
                                                <MenuItem value=''>-</MenuItem>
                                                {subjects.map(item => (
                                                    <MenuItem value={item.subjectId}>{item.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} spacing={1} >
                                        <Autocomplete
                                            disabled={readOnly}
                                            multiple disableCloseOnSelect
                                            limitTags={5}
                                            value={updatedUser && updatedUser.parkings && Array.isArray(updatedUser.parkings)?updatedUser.parkings:[]}
                                            onChange={(event, newValue) => {
                                                handleChangeParking(newValue);
                                            }}
                                            filterSelectedOptions
                                            id="parkings"
                                            options={parkings}
                                            getOptionLabel={(option) => {
                                                return option.parkingName;
                                            }}
                                            style={{width: '100%'}}
                                            renderInput={(params) => (
                                                <TextField {...params} label={t('PARKING')} fullWidth required
                                                    helperText={error && error.parkingIds
                                                        ? <span
                                                            className={classes.errorMessage}>{t('THIS_FIELD_IS_REQUIRED')}</span>
                                                        : null}
                                                />
                                            )}
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item xs={12} spacing={1} >
                                        <div className={classes.synchContainer}> 
                                            <Typography variant='h4' className={classes.syncTitle}>{t('USER_SYNCHRONIZATION')}</Typography> 
                                            <CustomButton label='Synchronizovat vybrane' height={'40px'} muiIcon={<CachedIcon/>} className={classes.syncButton} onClick={handleSynchronization}></CustomButton>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} spacing={1} >
                                        <CustomTable
                                            title=""
                                            columns={columns}
                                            data={userParkings}
                                            options={tableOptions}
                                            isLoading={false}
                                            loadAllData={false}
                                        />
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid container alignItems="stretch" spacing={2} sm={6}
                                style={{marginLeft: "auto", marginRight: "auto"}}>

                            <Typography variant="button" className={classes.description}>
                                {t('CHOOSE_ROLE')}
                            </Typography>

                            <div className={classes.editorWrapper}>
                            
                                <MaterialTable
                                    title=""
                                    search="false"
                                    icons={{
                                        SortArrow: ArrowUpward,
                                        DetailPanel: ChevronRight,
                                        Search: Search,
                                        ResetSearch: Clear
                                    }}
                                    data={roles}

                                    columns={[
                                        { title: t('ROLE_NAME'), field: 'name' },
                                        { title: t('ROLE_ACTIVE'), field: 'active', render: rowData => (rowData.active ? t('YES') : t('NO')), },
                                        { title: t('SUBJECT'), field: 'subject', render: rowData => (rowData.subjectName), },
                                    ]}

                                    options={{
                                        showTitle: false, paging:false, showTextRowsSelected:false,
                                        headerStyle: {
                                            position: "sticky",
                                            top: "0"
                                        },
                                        maxBodyHeight: "512px",
                                        
                                        toolbarButtonAlignment:"left"
                                    }}

                                    actions={readOnly?[]:[
                                        {
                                            icon: 'checked',
                                            tooltip: 'checked',
                                            onClick: (event, rowData) => {rowClickHandel(rowData)}
                                        },
                                        {
                                            icon: 'checkAll',
                                            tooltip: 'check all',
                                            onClick: (event, rowData) =>  headerClickHandel(),
                                            isFreeAction: true,
                                        },
                                    ]}

                                    localization={{
                                        header: {
                                            actions: ''
                                        },
                                    }}

                                    components={{
                                        Action: props => (
                                          <CustomCheckBox2
                                            onClick={(event) => props.action.onClick(event, props.data)}
                                            color={'white'}
                                            iconNumber={props.data.name?props.data.checked:headerChecked}
                                            paddingTop={props.data.name?'0':'8px'}
                                            paddingLeft={props.data.name?'20px':'0'}
                                            width='5'
                                            height='5'
                                            text={props.data.name?'':t('CHECK_ALL')}
                                          />
                                        )
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </form>
        </div>
    )
}

ExtUserUpdate.propTypes = {};
ExtUserUpdate.defaultProps = {};


const mapStateToProps = (store) => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ExtUserUpdate);


